import { useState, useEffect } from 'react'
import CircleNotificationsIcon from '@mui/icons-material/CircleNotifications'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import { Box, Menu, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { ROUTE_PATHS } from '~/constants/routes'
import useStats from '~/modules/dashboard/hooks/useStates'

const Navbar = () => {
  const navigate = useNavigate()
  const { notifications, markNotificationAsSeen, markAllNotificationsSeen } =
    useStats()
  const [renderNotifications, setRenderNotifications] = useState<any[]>([])
  const [anchorEl, setAnchorEl] = useState(null) // State to manage the menu anchor element

  const handleMenuOpen = (event: any) => {
    setAnchorEl(event.currentTarget)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const handleNotificationClick = async (notification: any) => {
    if (notification.seen === 0) {
      markNotificationAsSeen(notification?.id)
      await new Promise((resolve) => setTimeout(resolve, 2000))
    }
    const baseUrl = window.location.origin
    const url = new URL(notification?.link)
    const pathname = url.pathname + url.search + url.hash
    const newUrl = pathname.replace(baseUrl, '')
    // Navigate to the modified link
    window.location.href = newUrl
    setAnchorEl(null)
  }

  useEffect(() => {
    if (notifications?.data?.length > 10) {
      const data = notifications?.data.slice(0, 5) // Return the first 10 notifications
      setRenderNotifications(data)
    } else {
      setRenderNotifications(notifications.data) // Return all notifications
    }
  }, [notifications])

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
      <CircleNotificationsIcon
        sx={{ fontSize: '2rem', cursor: 'pointer' }}
        onClick={handleMenuOpen} // Open the menu on click
      />
      {notifications?.unseen_count > 0 && (
        <Box
          sx={{
            borderRadius: '50%',
            backgroundColor: 'rgb(255, 159, 67)',
            width: '1.5rem',
            height: '1.5rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            fontWeight: 'bold',
            fontSize: '1rem',
            position: 'absolute',
            top: '13px',
            right: '14px',
          }}
        >
          {notifications?.unseen_count}
        </Box>
      )}

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{ style: { width: '25rem' } }} // Set the width of the Paper component
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            margin: '1rem',
          }}
        >
          <Typography
            sx={{
              fontWeight: 'bold',
              fontSize: '1.2rem',
              color: 'rgb(255, 159, 67)',
            }}
          >
            Notifications
          </Typography>
          {notifications?.unseen_count > 0 && (
            <Typography
              sx={{
                fontSize: '.8rem',
                cursor: 'pointer',
                ':hover': {
                  color: 'blue',
                },
              }}
              onClick={() => {
                markAllNotificationsSeen()
              }}
            >
              Mark All As Seen
            </Typography>
          )}
        </Box>
        {renderNotifications?.map((notification: any) => (
          <Box
            key={notification.id}
            sx={{
              margin: '1rem',
              borderBottom: '1px solid #E2E2E2',
              paddingBottom: '1rem',
              cursor: 'pointer',
            }}
            onClick={() => {
              handleNotificationClick(notification)
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <Typography
                sx={{
                  fontWeight: 'bold',
                  fontSize: '1rem',
                }}
              >
                {notification?.title}
              </Typography>
              {notification.seen === 0 && (
                <FiberManualRecordIcon
                  sx={{ fontSize: '1rem' }}
                  onClick={() => {
                    markNotificationAsSeen(notification?.id)
                  }}
                />
              )}
            </Box>
            <Typography
              sx={{
                color:
                  notification?.type === 'issue_comment' ? 'red' : '#282828',
              }}
            >
              {notification?.message}
            </Typography>
          </Box>
        ))}
        {renderNotifications?.length > 0 ? (
          <Box
            sx={{
              textAlign: 'center',
              fontWeight: 'bold',
              fontSize: '1.2rem',
              cursor: 'pointer',
              ':hover': {
                color: 'blue',
              },
            }}
            onClick={() => {
              navigate(ROUTE_PATHS.NOTIFICATIONS)
              setAnchorEl(null)
            }}
          >
            See All Notifications
          </Box>
        ) : (
          <Typography sx={{ textAlign: 'center', fontSize: '1.2rem' }}>
            No Notifications
          </Typography>
        )}
      </Menu>
    </Box>
  )
}

export default Navbar
